import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalOptionPanelComponent } from '../../modal-option-panel/modal-option-panel.component';
import { LanguageService } from 'src/app/services/account/language.service';
import { SettingsService } from 'src/app/services/account/settings.service';

@Component({
  standalone: true,
  selector: 'app-account-verification-pending-step',
  templateUrl: './verification-pending-step.component.html',
  styleUrls: ['./verification-pending-step.component.scss'],
  imports: [CommonModule, ModalOptionPanelComponent]
})
export class VerificationPendingStepComponent {
  @Input() emailSent: boolean = false;

  @Output() resendEmail = new EventEmitter<void>();

  constructor(
    public languageService: LanguageService,
    public settingsService: SettingsService
  ) {}
}
